// import React, { useState, useRef } from "react";
// import { motion, useMotionValue, useTransform } from "framer-motion";
// import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
// import CloseIcon from "@mui/icons-material/Close";

// export default function ChatBot() {
//   const [open, setOpen] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [input, setInput] = useState("");

//   // Motion values for dragging the entire chat window
//   const x = useMotionValue(0);
//   const y = useMotionValue(0);

//   // Optional: Add slight scale/rotation effect while dragging
//   const scale = useTransform(
//     [x, y],
//     ([latestX, latestY]) => {
//       const distance = Math.sqrt(latestX * latestX + latestY * latestY);
//       return 1 + Math.min(distance / 1000, 0.1);
//     }
//   );

//   const sendMessage = () => {
//     if (!input.trim()) return;

//     setMessages([...messages, { from: "user", text: input }]);

//     setTimeout(() => {
//       setMessages((prev) => [
//         ...prev,
//         { from: "bot", text: "This is a demo response 😊" },
//       ]);
//     }, 600);

//     setInput("");
//   };

//   return (
//     <>
//       {/* Floating Draggable Button */}
//       {!open && (
//         <motion.button
//           drag
//           dragMomentum={false}
//           dragElastic={0.2}
//           dragTransition={{ bounceStiffness: 300, bounceDamping: 30 }}
//           whileDrag={{ scale: 1.15 }}
//           onClick={() => setOpen(true)}
//           className="fixed lg:bottom-6 bottom-[11rem] right-6 bg-yellow-500 shadow-lg w-16 h-16 rounded-full flex items-center justify-center cursor-move z-50"
//           style={{ x, y }}
//         >
//           <ChatBubbleOutlineIcon style={{ fontSize: 32, color: "white" }} />
//         </motion.button>
//       )}

//       {/* Draggable Chat Window */}
//       {open && (
//         <motion.div
//           drag
//           dragMomentum={false}
//           dragElastic={0.2}
//           dragTransition={{ bounceStiffness: 300, bounceDamping: 30 }}
//           dragConstraints={{ left: -window.innerWidth + 100, right: window.innerWidth - 400, top: -window.innerHeight + 100, bottom: window.innerHeight - 200 }}
//           whileDrag={{ scale: 1.03 }}
//           style={{ x, y, scale }}
//           initial={{ opacity: 0, y: 30, x: window.innerWidth > 640 ? -50 : 0 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="fixed bottom-6 right-6 w-80 bg-white shadow-2xl rounded-2xl overflow-hidden z-50 cursor-move"
//         >
//           {/* Header - also acts as drag handle */}
//           <div className="bg-yellow-500 text-white p-4 flex justify-between items-center cursor-grab active:cursor-grabbing">
//             <h3 className="font-bold">SOTA Support</h3>
//             <button onClick={() => setOpen(false)} className="hover:bg-yellow-600 rounded-full p-1">
//               <CloseIcon />
//             </button>
//           </div>

//           {/* Chat Messages */}
//           <div className="h-80 p-4 overflow-y-auto bg-gray-50">
//             {messages.map((msg, i) => (
//               <div
//                 key={i}
//                 className={`mb-3 flex ${
//                   msg.from === "user" ? "justify-end" : "justify-start"
//                 }`}
//               >
//                 <div
//                   className={`px-3 py-2 rounded-lg text-sm max-w-[80%] ${
//                     msg.from === "user"
//                       ? "bg-yellow-400 text-black"
//                       : "bg-white shadow"
//                   }`}
//                 >
//                   {msg.text}
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Input Box */}
//           <div className="flex border-t border-gray-200">
//             <input
//               type="text"
//               placeholder="Type your message..."
//               value={input}
//               onChange={(e) => setInput(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && sendMessage()}
//               className="flex-1 px-3 py-2 outline-none text-sm"
//               autoFocus
//             />
//             <button
//               onClick={sendMessage}
//               className="px-4 bg-black text-white font-semibold text-sm hover:bg-gray-800 transition"
//             >
//               Send
//             </button>
//           </div>
//         </motion.div>
//       )}
//     </>
//   );
// }
import React from "react";
import { motion, useMotionValue } from "framer-motion";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export default function ChatBot() {
  const x = useMotionValue(0);
  const y = useMotionValue(0);

  // You don't actually need Maytapi here for this behavior,
  // but I’ll leave the config in case you use it elsewhere.
  const CHATBOT_NUMBER = "919979648000"; // +91 99796 48000

  const sendWhatsappGreeting = () => {
    const messageText = "Hi";

    // Dealer → Chatbot
    const whatsappUrl = `https://wa.me/${CHATBOT_NUMBER}?text=${encodeURIComponent(
      messageText
    )}`;

    // This opens WhatsApp on dealer's device, from their number
    window.open(whatsappUrl, "_blank");
  };

  return (
    <>
      <motion.div
        drag
        style={{ x, y }}
        dragMomentum={false}
        dragElastic={0.2}
        dragTransition={{ bounceStiffness: 300, bounceDamping: 30 }}
        className="fixed lg:bottom-6 bottom-24 right-4 z-50 flex flex-col items-center gap-2 cursor-pointer"
      >
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="bg-white text-gray-800 text-xs px-3 py-1 rounded-full shadow-md border"
        >
          How , May I Help You ?
        </motion.div>

        <motion.button
          whileTap={{ scale: 0.9 }}
          whileDrag={{ scale: 1.15 }}
          onClick={sendWhatsappGreeting}
          className="
            bg-green-500 
            shadow-2xl 
            w-12 h-12 
            rounded-full 
            flex items-center justify-center 
          "
        >
          <WhatsAppIcon style={{ fontSize: 38, color: "white" }} />
        </motion.button>
      </motion.div>
    </>
  );
}
